import { doesFieldTypeMatch } from 'data/utils/ts_utils'

export const getCompatibleFields = (object: ObjectDto, field: Partial<FieldDto> | undefined) => {
    return object.fields.filter(
        (x) => !x.connection_options?.is_disabled && doesFieldTypeMatch(field, x)
    )
}
